var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PCurve"}},[_c('dv-border-box-8',[_c('div',{staticStyle:{"height":"90%"},attrs:{"id":"barsh1"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }